declare namespace $ {

	type $mol_button_minor__click_bog_merchquarium_cart_1 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['back'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_cart_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_3 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['heading'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_merchquarium_cart_5 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['lines'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_7 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['total_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_cart_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_merchquarium_cart_9 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['send_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_cart_10 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['send'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_bog_merchquarium_cart_11 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['send_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_minor__title_bog_merchquarium_cart_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_cart_13 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_merchquarium_cart_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__style_bog_merchquarium_cart_16 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['thumb_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_17 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['line_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_18 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['line_price'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_cart_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_merchquarium_counter__value_bog_merchquarium_cart_20 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['count'] >
		,
		ReturnType< $bog_merchquarium_counter['value'] >
	>
	type $bog_merchquarium_counter__enabled_bog_merchquarium_cart_21 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['editable'] >
		,
		ReturnType< $bog_merchquarium_counter['enabled'] >
	>
	type $mol_paragraph__title_bog_merchquarium_cart_22 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_cart['line_sum'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_row__sub_bog_merchquarium_cart_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $bog_merchquarium_cart extends $mol_list {
		back( next?: any ): any
		Back_icon( ): $mol_icon_arrow_left
		Back_title( ): string
		Back( ): $mol_button_minor
		heading( ): string
		Title( ): $mol_paragraph
		Empty( ): $mol_paragraph
		lines( ): readonly(any)[]
		Lines( ): $mol_list
		Notice( ): $mol_paragraph
		total_text( ): string
		Total( ): $mol_paragraph
		Summary( ): $mol_view
		send_title( ): string
		send( next?: any ): any
		send_enabled( ): boolean
		Send( ): $mol_button_major
		clear( next?: any ): any
		Clear( ): $mol_button_minor
		Actions( ): $mol_view
		Send_hint( ): $mol_paragraph
		thumb_style( id: any): Record<string, any>
		Thumb( id: any): $mol_view
		line_title( id: any): string
		Line_title( id: any): $mol_paragraph
		line_price( id: any): string
		Line_price( id: any): $mol_paragraph
		Line_info( id: any): $mol_view
		count( id: any, next?: number ): number
		Counter( id: any): $bog_merchquarium_counter
		line_sum( id: any): string
		Line_sum( id: any): $mol_paragraph
		catalog_link( ): string
		items( next?: Record<string, any> ): Record<string, any>
		editable( ): boolean
		Cart_title( ): string
		Order_title( ): string
		Unavailable( ): string
		Total_text( ): string
		Order_message( ): string
		Send_title( ): string
		Copy_title( ): string
		Copied_title( ): string
		Social_missing( ): string
		rows( ): readonly(any)[]
		Line( id: any): $mol_row
	}
	
}

//# sourceMappingURL=cart.view.tree.d.ts.map